import Vue from 'vue';
import Vuex from 'vuex';
import searchPlugin from 'vuex-search';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    beforeInitialFetch: true,
    filter: {
      field: null,
      fulltext: '',
      showAllCertifications: false,
      visibleItemsCount: 40,
    },
    certifications: [],
    fields: [],
  },
  plugins: [
    searchPlugin({
      resources: {
        certifications: {
          index: [],
          getter: () => [],
        },
      },
    }),
  ],

  getters: {
    allCertifications: state => state.certifications,
    topCertifications: state => state.certifications.filter(certification => certification.popular_certification),
    fields: state => state.fields,
    getFilterFulltext: state => state.filter.fulltext,
    getFilterField: state => state.filter.field,
    getShowAllCertifications: state => state.filter.showAllCertifications,
    getFilterVisibleItemsCount: state => state.filter.visibleItemsCount,
  },
  mutations: {
    setCertifications(state, certifications) {
      state.certifications = certifications.data;
    },
    setFields(state, certifications) {
      const fields = certifications.data.map(certification => certification.field_of_certifications);

      state.fields = fields.flat().filter((v,i,a) => a.findIndex(t => (t.id === v.id)) === i).sort(function(a, b){
        if(a.title < b.title) { return -1; }
        if(a.title > b.title) { return 1; }
        return 0;
      });
    },
    setFilterField(state, field) {
      if (field === 'null') {
        field = null;
      }
      state.filter.field = field;
    },
    setFilterFulltext(state, fulltext) {
      state.filter.fulltext = fulltext;
    },
    setShowAllCertifications(state, payload) {
      state.filter.showAllCertifications = payload;
    },
    setBeforeInitialFetch(state, value) {
      state.beforeInitialFetch = value;
    },
  },
  actions: {
    filterByField({ commit }, field) {
      commit('setFilterField', field);
    },
    filterByFulltext({ commit }, fulltext) {
      commit('setFilterFulltext', fulltext);
    },
    ShowAllCertifications({ commit }, payload) {
      commit('setShowAllCertifications', payload);
    },
  },
});

export default store;
